module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/our-services.d91358387f4c23939f32580f6bc8d054.jpg";